export enum Feature {
  INSIGHTFUL = 'insightful',
  INSIGHTFUL_ADMIN = 'insightful_admin',
  PURPOSEFUL = 'purposeful',
  RESOURCEFUL = 'resourceful',
}
